import config from "./config";

let ip = '127.0.0.1'

export default {
    ...config,
    debug: true,
    ssl: false,
    soon: false,
    urls: {
        api: ip + ':15031',
        cdn: ip + ':15032',
        panel: ip + ':15003',
        site: ip + ':15030'
    },
    directives: {
        connectSrc: [
            ip + ":15031", ip + ":15030",
            "*.jivosite.com",
            "wss://*.jivosite.com",
            "analytics.google.com"
        ],
        defaultSrc: [
            ip + ":15032",
            "*.jivosite.com"
        ],
        imgSrc: [
            "blob:", ip + ":15032",
            "www.facebook.com", "connect.facebook.net",
            "img.youtube.com", "i.ytimg.com", 'www.youtube.com',
            "*.jivosite.com",
            "*.tile.osm.org",
            "googleads.g.doubleclick.net", "www.google-analytics.com", "www.google.com", "www.google.az"
        ],
        fontSrc: [
            "data:", "fonts.gstatic.com"
        ],
        frameSrc: [
            "www.youtube.com", "www.facebook.com", "bid.g.doubleclick.net",
            'app.imajin.ai'
        ],
        styleSrc: [
            "*.jivosite.com", "cdnjs.cloudflare.com"
        ],
        scriptSrc: [
            "*.jivosite.com"
        ]
    },
    chat: {
        whatsapp: "994512079772",
        messenger: "hommebaku",
        instagram: "hommebaku",
        //jivoChat: 'hVa337YhLO'
    },
    pushNotification: true
}
